import React, { useState, useEffect, useRef } from 'react';
import './App.scss';
// import 'antd/dist/antd.css';
// import "antd/dist/antd.min.css";
import 'antd/dist/reset.css';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
// import "@fortawesome/fontawesome-free/css/all.min.css";

import { textContent } from './types/data.global';
import _ from 'lodash';
// import styled from "styled-components";
import cvUrl from './assets/images/1-about/ap__cv__2026Fall_AP_FSU_yifang_wang.pdf'

import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';

import { ConfigProvider } from 'antd';
import { theme as antdTheme } from 'antd';
// import PaletteBar from './theme/PaletteBar'; // the palette debug bar, hidden for the live site
import { usePalette } from './theme/PaletteContext';
import { MenuProps } from 'antd';
import { Layout, Anchor, theme } from 'antd';
import { Row, Col } from 'antd';
import { Spin, Divider } from 'antd';


import {
  FilePdfFilled,
  MenuOutlined,
  CloseOutlined
} from '@ant-design/icons';

import HomePage from './components/HomePage';
import DataArtPage from './components/DataArtPage';
import LifePage from './components/LifePage';
import WhalesLabPage from './components/WhalesLabPage';
import LabFooter, { LAB_PATHS } from './components/WhalesLabPage/LabFooter';
import RecruitingPage from './components/HomePage/Recruiting';

const { Header, Content } = Layout;

function App() {
  const { theme: palette } = usePalette();

  type MenuItem = Required<MenuProps>['items'][number]
  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }
  const items: MenuItem[] = [
    getItem('', 'sub1', <FilePdfFilled />, [
      getItem('Option 1', '1'),
      getItem('Option 2', '2'),
      getItem('Option 3', '3'),
      getItem('Option 4', '4'),
    ]),
    // getItem('Navigation Two', 'sub2', <FilePdfFilled />, [
    //   getItem('Option 5', '5'),
    //   getItem('Option 6', '6'),
    //   getItem('Submenu', 'sub3', null, [getItem('Option 7', '7'), getItem('Option 8', '8')]),
    // ]),
    // getItem('Navigation Three', 'sub4', <FilePdfFilled />, [
    //   getItem('Option 9', '9'),
    //   getItem('Option 10', '10'),
    //   getItem('Option 11', '11'),
    //   getItem('Option 12', '12'),
    // ]),
  ]


  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  }

  // set height
  const [headerHeight, setHeaderHeight] = useState('64px'); // Initial header height (a standard nav bar)
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setHeaderHeight('56px'); // Height when scrolled down
        setIsHeaderCollapsed(true);
      } else {
        setHeaderHeight('64px'); // Default height
        setIsHeaderCollapsed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array means this effect runs once on mount and clean up on unmount


  // handle page loading and navigation
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    setLoading(false);
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [location]);
  const handleAnchorClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    link: { href: string; title: React.ReactNode }
  ) => {
    e.preventDefault();

    if (link.href === cvUrl) {
      // Open the CV in a new tab
      window.open(link.href, '_blank', 'noopener,noreferrer');
      return;
    }

    setLoading(true);

    // Close mobile menu when navigating
    if (isVisible) {
      setIsVisible(false);
    }

    if (link.href.startsWith('/')) {
      // If navigating to a different route, use `navigate`
      navigate(link.href);
    } else if (link.href.startsWith('#')) {
      // If navigating within the current page (anchors)
      const targetId = link.href.slice(1);
      if (location.pathname !== '/') {
        // If not on the home page, navigate to the root first
        navigate('/');
        setTimeout(() => {
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        // If on the same page, scroll directly
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    } else {
      // External link or other link
      window.location.href = link.href;
    }

    setLoading(false);
  };


  // mobile mode 菜单
  const [isFolded, setIsFolded] = useState('none')
  const [menuCollapseClassname, setMenuCollapseClassname] = useState('collapse-menu-div')
  const handleFoldingNav = () => {
    if (isFolded === 'none') {
      setIsFolded('block')
      setMenuCollapseClassname('collapse-menu-div active')
    } else {
      setIsFolded('none')
      setMenuCollapseClassname('collapse-menu-div')
    }
  }
  const handleCloseNav = () => {
    if (isFolded === 'none') {
      setIsFolded('block')
      setMenuCollapseClassname('collapse-menu-div active')
    } else {
      setIsFolded('none')
      setMenuCollapseClassname('collapse-menu-div')
    }
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: palette.dark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: palette.antd.primary, // https://ant.design/docs/react/customize-theme
          colorSplit: palette.dark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(5, 5, 5, 0.06)',
          colorText: palette.antd.text,
          colorBgLayout: location.pathname === '/dataArtPage' ? 'var(--site-night, #000)' : palette.antd.bg, // Set background color based on route
        },
      }}
    >
      {/* <PaletteBar /> */}
      <Layout style={{ backgroundColor: location.pathname === '/dataArtPage' ? 'var(--site-night, #000)' : 'var(--site-bg, #fff)' }}>
        <Header
          style={{
            display: 'flex',
            alignItems: 'center',
            height: headerHeight,
            backgroundColor: location.pathname === '/dataArtPage' ? 'var(--site-night-header, #1D1D1D)' : 'var(--site-header-bg)',
            // the data-art gallery is dark, so its header keeps light text
            ...(location.pathname === '/dataArtPage' ? { '--site-header-bg': 'var(--site-night-header, #1D1D1D)', '--site-header-ink': '#FFFFFF', '--site-header-accent': '#BEA060', '--site-header-hover': '#CEB888', '--site-header-rule': 'transparent' } as React.CSSProperties : {}),
            color: location.pathname === '/dataArtPage' ? '#666' : '#3d3d3d'
          }}
          className={`header-div ${isHeaderCollapsed ? 'collapsed' : ''}`}
        >
          <Row justify="space-between" style={{width: '100%', paddingLeft: 13, paddingRight: 16}}>
            <Col xs={20} sm={20} md={20} lg={8} className='left-div'>
              <div className='text-container' onClick={() => navigate('/')}>
                <div className='name'>YIFANG WANG</div>
              </div>
            </Col>
            <Col xs={0} sm={0} md={0} lg={16} id='right-div' className='right-div'>
              <div className='right-div-inside'>
                <Anchor
                  direction="horizontal"
                  onClick={(e: React.MouseEvent<HTMLElement>, link: { href: string; title: React.ReactNode }) => handleAnchorClick(e as React.MouseEvent<HTMLAnchorElement>, link)}
                  style={{color: 'var(--site-header-ink)'}}
                  items={[
                    {
                      key: 'aboutPage',
                      href: '#aboutPage',
                      title: 'ABOUT',
                    },
                    // {
                    //   key: 'newsPage',
                    //   href: '#newsPage',
                    //   title: 'NEWS',
                    // },
                    {
                      key: 'researchPage',
                      href: '#researchPage',
                      title: 'RESEARCH',
                    },
                    {
                      key: 'dataArtPage',
                      href: '/dataArtPage',
                      title: <Link to="/dataArtPage" target="_blank">
                                DATA-DRIVEN ART
                             </Link>,
                      // href: '#dataArtPage',
                      // title: 'DATA-DRIVEN ART',
                    },
                    {
                      key: 'whalesLab',
                      href: '/whalesLab',
                      title: <Link to="/whalesLab">
                                WHALES LAB
                             </Link>,
                    },
                    {
                      key: 'recruitingPage',
                      href: '/recruitingPage',
                      title: <Link to="/recruitingPage">
                                WORK WITH ME
                             </Link>,
                    },
                    // {
                    //   key: 'experiencePage',
                    //   href: '#experiencePage',
                    //   title: 'EXPERIENCE',
                    // },
                    // {
                    //   key: 'contactPage',
                    //   href: '#contactPage',
                    //   title: 'CONTACTS',
                    // },
                    // {
                    //   key: 'lifePage',
                    //   href: '/lifePage',
                    //   title: <Link to="/lifePage">
                    //             LIFE
                    //          </Link>,
                    //   // title: 'LIFE',
                    //   // target: '_blank',
                    // },
                    // {
                    //   key: 'CV',
                    //   href: cvUrl,
                    //   title: 'CV',
                    // },
                  ]}
                />
              </div>
            </Col>
            <Col xs={4} sm={4} md={4} lg={0} id='right-div-collapse' className='right-div-collapse' onClick={toggleVisibility}>
              <div className='menu'>
                <MenuOutlined style={{ color: 'var(--site-header-ink)' }} />
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} className={`right-div-collapse ${isVisible ? 'visible' : 'hidden'}`}>
              <div className={`collapse-menu-div`}>
                <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/#aboutPage" onClick={(e) => handleAnchorClick(e, { href: '#aboutPage', title: 'ABOUT' })} style={{ color: 'var(--site-header-ink)' }}>ABOUT</Link>
                </Divider>
                <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/#researchPage" onClick={(e) => handleAnchorClick(e, { href: '#researchPage', title: 'RESEARCH' })} style={{ color: 'var(--site-header-ink)' }}>RESEARCH</Link>
                </Divider>
                {/* <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/#newsPage" onClick={(e) => handleAnchorClick(e, { href: '#newsPage', title: 'NEWS' })} style={{ color: 'var(--site-header-ink)' }}>NEWS</Link>
                </Divider> */}
                <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/dataArtPage" target="_blank" style={{ color: 'var(--site-header-ink)' }}>DATA-DRIVEN ART</Link>
                </Divider>
                <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/whalesLab" onClick={(e) => handleAnchorClick(e, { href: '/whalesLab', title: 'WHALES LAB' })} style={{ color: 'var(--site-header-ink)' }}>WHALES LAB</Link>
                </Divider>
                <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/recruitingPage" onClick={(e) => handleAnchorClick(e, { href: '/recruitingPage', title: 'WORK WITH ME' })} style={{ color: 'var(--site-header-ink)' }}>WORK WITH ME</Link>
                </Divider>
                {/* <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/#contactPage" onClick={(e) => handleAnchorClick(e, { href: '#contactPage', title: 'CONTACTS' })} style={{ color: 'var(--site-header-ink)' }}>CONTACTS</Link>
                </Divider> */}
                {/* <Divider className='collapse-menu-div-unit' plain>
                  <Link to="/lifePage" target="_blank" style={{ color: 'var(--site-header-ink)' }}>LIFE</Link>
                </Divider> */}
                {/* <Divider className='collapse-menu-div-unit' plain>
                  <a href={cvUrl} target="_blank" style={{ color: 'var(--site-header-ink)' }}>CV</a>
                </Divider> */}
              </div>


              {/* <div className={menuCollapseClassname}>
                <div className='close-div collapse-menu-div-unit'>
                  <div className='menu' onClick={handleCloseNav}>
                    <CloseOutlined />
                  </div>
                </div>
                <Divider className='collapse-menu-div-unit' plain><a href="#backgroundPage">BACKGROUND</a></Divider>
                <Divider className='collapse-menu-div-unit' plain><a href="#innovationinsightsPage">INNOVATIONINSIGHTS</a></Divider>
                <Divider className='collapse-menu-div-unit' plain><a href="#frameworkPage">FRAMEWORK</a></Divider>
                <Divider className='collapse-menu-div-unit' plain><a href="#examplePage">EXAMPLE</a></Divider>
                <Divider className='collapse-menu-div-unit' plain><a href="#aboutPage">TEAM</a></Divider>
                <Divider className='collapse-menu-div-unit' plain><a href="#contactPage">MATERIAL</a></Divider>
              </div> */}
            </Col>
          </Row>
        </Header>
        <Content >
        {/* style={{ padding: '72px 88px' }}  */}
          {loading ? (
            <Spin
              tip="Loading..."
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}
            />
          ) : (
            <Routes>
              <Route
                path="/"
                element={
                  // Your home page content including the anchor navigation
                  <div className='research-page'>
                    <div className='content-div'>
                      <HomePage textContent={textContent} />
                    </div>
                  </div>
                }
              />
              <Route path="/lifePage" element={
                <div className='research-page'>
                  <div className='content-div'>
                    <LifePage />
                  </div>
                </div>
              } />
              <Route path="/dataArtPage" element={
                <div className='data-art-page'>
                  <div className='content-div'>
                    <DataArtPage />
                  </div>
                </div>
              } />
              <Route path="/whalesLab" element={<WhalesLabPage />} />
              {/* the old lab members URL now opens the WHALES Lab page */}
              <Route path="/labMemberPage" element={<WhalesLabPage />} />
              <Route path="/recruitingPage" element={<RecruitingPage />} />
            </Routes>
          )}
          {/* <Routes>
            <Route path="/" element={
              // Your home page content including the anchor navigation
              <HomePage textContent={textContent} />
            } />
            <Route path="/lifePage" element={<LifePage />} />
          </Routes> */}
        </Content>
        {/* every page ends with the WHALES Lab footer; the WHALES Lab and Work with me pages render it inside their own page */}
        {![...LAB_PATHS, '/recruitingPage'].includes(location.pathname) && <div className='whales-page site-foot'><LabFooter night={location.pathname === '/dataArtPage'} /></div>}
      </Layout>
    </ConfigProvider>
  )
}


export default App;
